module.exports = __webpack_public_path__ + "static/img/city_bg.1cdf0d5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/city_bg.png
// module id = fDoB
// module chunks = 1